module.exports = __webpack_public_path__ + "img/07.e81bdba9.png";